<template>
    <div style="width: 100%; height: 100%">
        <main-layout>
            <template #header>
                <main-header :title="'메뉴얼 관리' | translate"/>
            </template>
            <template #body>
                <div class="flex-style-row">
                    <!--좌측 메뉴 관련 부분입니다.-->
                    <div class="box-style-border menus-list-style menus-container">
                        <new-manual-tree-menu-slot
                            :tree-items-menus="treeItemsMenus"
                            @moving-select-detail="movingSelectDetail"
                            @moving-write-detail="movingWriteDetail"
                            @moving-manual-rq="movingManualRq"
                            :menus="menus"
                            :click-menu-id="clickMenuId"
                        />
                    </div>
                    <!--우측 상세 부분 입니다.-->
                    <div v-if="showDetail" class="flex-style-column box-style-border detail-container">
                        <new-manual-detail
                            :manual="manual"
                            :manual-write-data="manualWriteData"
                            :click-menu-depth="clickMenuDepth"
                            @moving-write-detail="movingWriteDetail"
                            @change-write-data="changeWriteData"
                            @insert-data-rq="insertDataRq"
                            @update-data-rq="updateDataRq"

                        />
                    </div>
                </div>
            </template>
        </main-layout>
        <div class="loading_wrap" v-show="isLoading">
            <div class="loading"></div>
            <div class="loading"></div>
            <div class="loading"></div>
        </div>
    </div>
</template>


<script>

/**
 * 게시판 -> 새 메뉴얼 관리 클릭했을때 나오는 컴포넌트
 * MPS 에서 메뉴얼을 Admin 관리자에서 컨트롤 하기위해 만들었습니다
 * 기본적으로 메뉴랑 상세로 구분 되있습니다.
 * 전반적인 컨트롤은 여기서 합니다.
 *
 */
import MainLayout from "@/components/common/layout/MainLayout";
import MainHeader from "@/components/common/layout/MainHeader";
import NewManualDetail from "@/views/newManual/NewManualDetail";
import arrayToTree from "@/utils/array-to-tree";
import NewManualTreeMenuSlot from "@/views/newManual/NewManualTreeMenuSlot";
import {PATH} from "@/constants";


export default {
    name: "NewManual",
    components: {
        MainLayout,
        MainHeader,
        NewManualDetail,
        NewManualTreeMenuSlot,
    },
    data() {
        return {
            menus: undefined,
            manual: undefined,//api요청시 받아온 manual 정보를 저장합니다. 데이터를 수정 하지 않고 고유정보를 보관합니다.
            showDetail: false, //단순히 처음에 상세화면을 안보여주기 위함입니다.
            isLoading:false, //progress bar 를 동작하기 위함입니다.
            clickMenuDepth:undefined,//상세화면에서 완료 수정 삭제 버튼을 2depth 3depth 메뉴마다 구분하기위해 사용됩니다.
            clickMenuId:undefined,//클릭한 메뉴의 manualId를 저장합니다. 메뉴 색 변경할때 쓰입니다.
            manualWriteData:{ //상세화면에서 작성하고 수정하는 데이터들을 전부 여기서 관리합니다.
                content:undefined,
                subContent:undefined,
                title:undefined,
                showYn:false,
                parentId:undefined,
            }
        }
    },
    computed: {
        /**
         *  배열을 일차원 구조가 아니라 하이라키 구조로 만듭니다.
         * arrayToTree은 정재위 책임님이 제공해주신 메서드로 확용했습니다.
         * @returns {[]|*}
         */
        treeItemsMenus() {
            if(!this.menus)  return undefined
            const copy = JSON.parse(JSON.stringify( this.menus)); //깊은 복사 안하면 arrayToTree에서 값이 이상하게 나옵니다.
            const menusTree = arrayToTree(copy,
                {idKey: "manualId", parentKey: "parentId"})

            /**
             * depth가 1인 메뉴 depth가 2인 메뉴 전부 sequence에 맞게 오름차순 정렬을 합니다.
             */
            menusTree.sort((a, b)=> a.sequence - b.sequence)
            menusTree.forEach((menu)=>{
                if(!!menu.children) {
                    menu.children.sort((a, b)=> a.sequence - b.sequence)
                    menu.children.forEach((childrenMenu)=>{
                        if(!!childrenMenu.children) {
                            childrenMenu.children?.sort((a, b)=> a.sequence - b.sequence)
                        }
                    })
                }
            })
            return menusTree
        },


    },
    watch: {
        /**
         * manual이 바뀔때마다 (select 단건조회, manual insert)
         * manualWriteData를 바꿉니다.
         */
        manual:{
            immediate:true,
            handler(newValue){
                if(!newValue) return;
                const{title,content,subContent,showYn,parentId} = newValue
                this.manualWriteData={ title,content,subContent,parentId,showYn : showYn==='Y' }
            }
        }
    },
    methods: {
        /**
         * 메뉴얼에대한 부분을 초기화 하기위해 만들었습니다.
         */
        init() {
            this.manualWriteData ={
                parentId:undefined,
                content:undefined,
                subContent:undefined,
                title:undefined,
                showYn:false
            }
        },
        /**
         * 제목이랑 내용을 작성할대 emit으로 받은 데이터를 manualWriteData에 넣습니다.
         * @param newValue
         */
        changeWriteData(newValue){
            this.manualWriteData=newValue
        },
        /**
         * plus 버튼을 클릭시 동작하고
         * 작성하는 상세창을 열어줍니다.
         * 비어있는 메뉴얼 메뉴를 생성해주는데 중복으로는 생성 불가하고
         * 다른메뉴의 +버튼을 클릭하면 이전 비어있는 메뉴얼 메뉴가 사라집니다.
         *
         */
        async movingWriteDetail(clickMenu) {
            this.clickMenuId=undefined

            const perform = () => {
                this.isLoading=true;
                this.showDetail = true //상세화면 나오게 하기
                this.clickMenuDepth = 2 //depth로 상세쪽 버튼 구분
                this.init() //제목 내용 초기화
                this.manualWriteData.parentId=clickMenu.manualId
                this.isLoading=false;
            }
            //+버튼 클릭시 비어있는 메뉴얼을 생성하는 로직입니다.
            const blankManualMenu = () => {
                let seq = !clickMenu.children ? 0 : clickMenu.children[clickMenu.children.length -1].sequence
                seq++
                const newItem = {
                    content: '',
                    subContent: '',
                    deleteYn: 'N',
                    depth: 3,
                    locale: "ko-KR",
                    manualId: -1, //백엔드에서 manualId를 부여해주지만 임의상 -1 넣었습니다.
                    modifier: '',
                    parentId: clickMenu.manualId,
                    register: '',
                    sequence: seq,
                    showYn: 'N',
                    title: '',
                }
                this.menus.push(newItem)
                this.manual = newItem
            }
            if(this.showDetail){
                this.$confirm("작성하는 메뉴로 이동 하시겠습니까?")
                .then(async ()=>{
                    await this.requestMenuData() //메뉴를 업데이트 합니다.
                    perform()
                    blankManualMenu()
                })
            }else{
                await this.requestMenuData() //메뉴를 업데이트 합니다.
                perform()
                blankManualMenu()
            }
        },


        /**
         * 3depth에 있는 메뉴얼을 클릭시 해당 조건을 수행후 맞다면 아래 perform 동작을 수행합니다.
         * 1. 상세창 보여주기
         * 2. 메뉴 데이터 업데이트
         * 3. 메뉴얼 데이터 업데이트
         */
        movingSelectDetail(clickManualMenu) {
            const perform = ()=>{
                this.clickMenuId = clickManualMenu.manualId
                this.showDetail = true
                this.clickMenuDepth = 3
                this.manualWriteData.parentId=clickManualMenu.parentId
                this.requestMenuData()
                this.requestManualData(clickManualMenu.manualId)
            }
            /**
             * 메뉴얼을 클릭시 dialog 가 나오는지에 대한 여부랑 위에 조건을 수행하는지에
             * 대한 여부를 판별합니다.
             * @type {boolean}
             */

            //같은 메뉴얼인지 판별하고 맞다면 perform 동작을 안합니다.
            const sameManualClick = !!this.manual && this.manual.manualId ===clickManualMenu.manualId
            //비어있는 메뉴는 클릭할 수 없습니다.
            const blankManualClick = clickManualMenu.manualId === -1
            if(sameManualClick || blankManualClick) return //같은 메뉴일때는 동작 안하게 하기
            //dialog 를 보여줄지에 대한 판별을 합니다. 1. 상세창이 나와있는 경우 2.보여진 메뉴얼과 클릭한 메뉴얼이 다른 경우
            const showDialog = this.showDetail
            if(showDialog){
                this.$confirm(`${clickManualMenu.title} 메뉴로 이동 하시겠습니까?`)
                    .then(()=>perform())//모달에서 확인 버튼 클릭시 동작
            }else{
                perform()//다른 메뉴일때 동작
            }
        },


        /**
         * 작성 완료버튼을 클릭했을때 동작합니다.
         * 메뉴얼 데이터를 업데이트 해줍니다.
         * 상세창을 닫습니다.
         */
        async insertDataRq() {
            const bodyData={
                parentId: this.manualWriteData.parentId,
                sequence: this.lastSequence(this.manualWriteData.parentId),
                depth:3,
                title:this.manualWriteData.title,
                content:this.manualWriteData.content,
                subContent: this.manualWriteData.subContent,
                showYn: this.manualWriteData.showYn?'Y':'N'
            }
            await this.requestComplete(bodyData)
            await this.requestMenuData()
            this.clickMenuId=undefined
            this.showDetail = false
            this.manual=undefined
        },
        /**
         * insertDataRq 에서 sequence를 찾는 부분이고
         * parentId를 받아서 클릭한 메뉴를 찾고 그 메뉴에서 여러 메뉴얼중
         * 마지막 sequence를 구해 반환합니다.
         */
        lastSequence(parentId){
            //2depth에 있는 메뉴 찾기
            const sameManual = this.menus.filter((menu)=> menu.parentId ===parentId)
            const sequence = sameManual ?
                sameManual[sameManual.length-1].sequence+1
                : 1;
            return sequence
        },

        /**
         * 수정 완료 버튼 클릭시랑 삭제 버튼을 클릭했을때 동작합니다.
         * 삭제완료시에는 상세창을 닫습니다.
         */
        async updateDataRq(deleteYn) {
            const bodyData={
                manualId:this.manual.manualId,
                parentId: this.manualWriteData.parentId,
                sequence:this.manual.sequence, //배열의 마지막 번호 구해야됩니다.
                depth:3, //항상 고정값
                title:this.manualWriteData.title,
                content:this.manualWriteData.content,
                subContent: this.manualWriteData.subContent,
                showYn: this.manualWriteData.showYn?'Y':'N',
                deleteYn:deleteYn
            }
            await this.requestUpdate(bodyData)
            await this.requestMenuData()
            this.clickMenuId=undefined
            this.showDetail = false
            this.manual=undefined
        },
        /**
         * 클릭한 메뉴(clickMenu), 바꾸려는 메뉴(menuStatus)를
         * sequence만 바꿔서 update요청을 보냅니다.
         */
        async movingManualRq(clickMenu,menuStatus){
            const bodyDataA={
                manualId:clickMenu.manualId,
                parentId: clickMenu.parentId,
                sequence:menuStatus.sequence,
                depth:3, //항상 고정값
                title:clickMenu.title,
                content:clickMenu.content,
                subContent: clickMenu.subContent,
                showYn: clickMenu.showYn,
                deleteYn:clickMenu.deleteYn
            }
            const bodyDataB={
                manualId:menuStatus.manualId,
                parentId: menuStatus.parentId,
                sequence:clickMenu.sequence,
                depth:3, //항상 고정값
                title:menuStatus.title,
                content:menuStatus.content,
                subContent: menuStatus.subContent,
                showYn: menuStatus.showYn,
                deleteYn:menuStatus.deleteYn
            }
            await this.requestUpdate(bodyDataA)
            await this.requestUpdate(bodyDataB)
            await this.requestMenuData()
        },


        /**
         * 메뉴을 요청 받는 부분입니다.
         * @returns {Promise<void>}
         */
        async requestMenuData() {
            this.isLoading=true;
            const res = await this.$request(PATH.NEW_MANUAL.LIST)
                .get()
                .catch((e)=>{
                    this.isLoading =false;
                    alert('조회실패')
                })
                .enqueue()
            this.isLoading = false;
            this.menus = res.data
        },
        /**
         * 각 저장된 메뉴얼 메뉴마다 클릭시 데이터 베이스에서 저장된 메뉴얼을 가지고 옵니다.
         * @returns {Promise<void>}
         */
        async requestManualData(menuId) {
            this.isLoading=true;
            const res = await this.$request(`${PATH.NEW_MANUAL.DETAIL}/${menuId}`)
                .get()
                .catch((e)=>{
                    this.isLoading =false;
                    alert('조회실패')
                })
                .enqueue()
            this.isLoading = false;
            this.manual=res

        },
        /**
         * insert 요청 하는 부분입니다
         * @param bodyData
         * @returns {Promise<void>}
         */
        async requestComplete(bodyData) {
            this.isLoading=true;
            await this.$request(PATH.NEW_MANUAL.INSERT)
                .setObject({
                    ...bodyData
                })
                .catch((e)=>{
                    this.isLoading =false;
                    alert('조회실패')
                })
                .enqueue()
            this.isLoading = false;
        },
        /**
         * update요청하는 부분입니다.
         * @returns {Promise<void>}
         */
        async requestUpdate(bodyData) {
            this.isLoading=true;
            await this.$request(PATH.NEW_MANUAL.UPDATE)
                .setObject({
                    ...bodyData
                })
                .catch((e)=>{
                    this.isLoading =false;
                    alert('조회실패')
                })
                .enqueue()
            this.isLoading = false;

        }


    },
    mounted() {
        this.requestMenuData()

    }
}
</script>

<style scoped>
/*공통으로 사용하는 Css 부분입니다*/
.flex-style-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.flex-style-row {
    display: flex;
    height: 100%;
}

/*메뉴랑 상세부분 border 스타일 부분*/
.box-style-border {
    border: 1px solid #9f9f9f;
    border-radius: 10px;
}


/*메뉴 컨테이너*/
.menus-list-style {
    list-style: none;
}

.menus-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    width: 250px;
    overflow: auto
}

/*상세 컨테이너*/
.detail-container {
    margin-left: 1rem;
    width: 80%;
    height: 100%;
    padding: 20px;
}


/*로딩 부분입니다.*/
.loading_wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    background: rgba(0,0,0,0.5);
}

.loading {
    width: 8px;
    height: 8px;
    background: #aaaaaa;
    border-radius: 50%;
    animation: loading-cricle 1.5s infinite ease-in-out;
    display: inline-block;
    margin-right: 8px;
}

.loading:nth-child(2) {
    animation-delay: .5s;
}

.loading:nth-child(3) {
    animation-delay: 1s;
}
@keyframes loading-cricle {
    0% {
        opacity: .4;
        transform: scale(1, 1);
    }
    50% {
        opacity: 1;
        transform: scale(1.2, 1.2);
    }
    100% {
        opacity: .4;
        transform: scale(1, 1);
    }
}


</style>